document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.read-more-toggle').forEach(button => {

    button.addEventListener('click', function () {

      const content = this.previousElementSibling;

      if (!content) return;

      content.classList.toggle('expanded');

      this.textContent = content.classList.contains('expanded')
        ? 'Show Less'
        : 'Read More';

    });

  });

});